<footer
  class="footer"
  id="app-footer"
  [class.fixed-bottom]="settings.theme.footerIsFixed"
>
  <div class="container">
    <div class="footer__logo">
      @if (hideLinks) {
        <img
          class="logo-img"
          src="assets/img/logos/logo_anheuser_busch_white.png"
        />
      }
      @if (!hideLinks) {
        <a class="logo" id="footer-logo-link" routerLink="/">
          <img
            class="logo-img"
            src="assets/img/logos/logo_anheuser_busch_white.png"
          />
        </a>
      }
    </div>
    <div class="footer__links">
      <span
        ><a
          id="footer-terms-link"
          class="link font-6 color-white footer__link separator"
          (click)="showTermsAndConditions()"
          >Terms &amp; Conditions</a
        ></span
      >
      <span
        ><a
          id="footer-privacy-policy-link"
          class="link font-6 color-white footer__link"
          href="https://www.hhglobal.com/privacy-policy"
          target="_blank"
          >Privacy and Tracking Policy</a
        ></span
      >
    </div>
    <div class="footer__copywright">
      <span class="powered-by text-center">Powered By</span>
      <img class="iw-footer" src="assets/img/logos/hhglobal_white.png" />
      <span class="underline text-center"
        >&copy;{{ year }} HH Global, Inc.</span
      >
    </div>
  </div>
</footer>
